"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postCatalogueItems = void 0;
/**
 * Allows you to create new catalogue items, it will return an error if you pass an existing SKU
 */
var postCatalogueItems = function (instance) {
    return function (id, body, config) {
        return instance.post("/catalogues/".concat(id, "/items"), body, config);
    };
};
exports.postCatalogueItems = postCatalogueItems;
